import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Button } from '@mui/material'
import CustomInput from '../muiComponents/customInput'
import { search, searchBox } from './style'

interface Props {
    textValue: string
    placeholder?: string
    onChangeText: (text: string) => void
    onSearch: () => void
}

const Search: React.FC<Props> = ({
    textValue,
    placeholder,
    onSearch,
    onChangeText,
}) => {
    const { formatMessage } = useIntl()

    return (
        <Box>
            <Box sx={searchBox}>
                <CustomInput
                    value={textValue}
                    sx={search}
                    margin="none"
                    type="text"
                    placeholder={placeholder || formatMessage({ id: 'search' })}
                    size="small"
                    onChange={(e) => onChangeText(e.target.value)}
                />

                <Button
                    variant="contained"
                    onClick={onSearch}
                >
                    {formatMessage({ id: 'search' })}
                </Button>
            </Box>
        </Box>
    )
}

export default Search
